/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  RevokeAPIKeyForUserIntegratorOptions,
  RevokeAPIKeyForUserIntegratorStatus200,
  RevokeAPIKeyForUserIntegratorStatus404,
  RevokeAPIKeyForUserIntegratorStatus500,
} from '../types/RevokeAPIKeyForUserIntegrator'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { revokeAPIKeyForUserIntegrator } from '../clients/revokeAPIKeyForUserIntegrator'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const revokeAPIKeyForUserIntegratorMutationKey = () =>
  [{ url: '/v1/user/:user_id/apikey/:key_id/revoke' }] as const

export function revokeAPIKeyForUserIntegratorMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = revokeAPIKeyForUserIntegratorMutationKey()
  return mutationOptions<
    RevokeAPIKeyForUserIntegratorStatus200,
    ResponseErrorConfig<
      RevokeAPIKeyForUserIntegratorStatus404 | RevokeAPIKeyForUserIntegratorStatus500
    >,
    RevokeAPIKeyForUserIntegratorOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ path }) => {
      return revokeAPIKeyForUserIntegrator({ ...config, path, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @summary Revoke apikey for a user: admin or integrator only
 * {@link /v1/user/:user_id/apikey/:key_id/revoke}
 */
export function useRevokeAPIKeyForUserIntegrator<TContext>(
  options: {
    mutation?: UseMutationOptions<
      RevokeAPIKeyForUserIntegratorStatus200,
      ResponseErrorConfig<
        RevokeAPIKeyForUserIntegratorStatus404 | RevokeAPIKeyForUserIntegratorStatus500
      >,
      RevokeAPIKeyForUserIntegratorOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? revokeAPIKeyForUserIntegratorMutationKey()

  const baseOptions = revokeAPIKeyForUserIntegratorMutationOptions(config) as UseMutationOptions<
    RevokeAPIKeyForUserIntegratorStatus200,
    ResponseErrorConfig<
      RevokeAPIKeyForUserIntegratorStatus404 | RevokeAPIKeyForUserIntegratorStatus500
    >,
    RevokeAPIKeyForUserIntegratorOptions,
    TContext
  >

  return useMutation<
    RevokeAPIKeyForUserIntegratorStatus200,
    ResponseErrorConfig<
      RevokeAPIKeyForUserIntegratorStatus404 | RevokeAPIKeyForUserIntegratorStatus500
    >,
    RevokeAPIKeyForUserIntegratorOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    RevokeAPIKeyForUserIntegratorStatus200,
    ResponseErrorConfig<
      RevokeAPIKeyForUserIntegratorStatus404 | RevokeAPIKeyForUserIntegratorStatus500
    >,
    RevokeAPIKeyForUserIntegratorOptions,
    TContext
  >
}
